var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.694 3.7951C14.102 3.38445 14.102 2.71865 13.694 2.30799C13.286 1.89734 12.6244 1.89734 12.2164 2.30799L7.30602 7.25644C6.89799 7.6671 6.89799 8.3329 7.30602 8.74356L12.2164 13.692C12.6244 14.1027 13.286 14.1027 13.694 13.692C14.102 13.2814 14.102 12.6156 13.694 12.2049L9.52241 8L13.694 3.7951ZM4 2C3.44772 2 3 2.44772 3 3V13C3 13.5523 3.44772 14 4 14C4.55228 14 5 13.5523 5 13V3C5 2.44772 4.55228 2 4 2Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveBack);
export default __webpack_public_path__ + "static/media/move-back.5ba0b7c7d1eba0e467888e42d789e046.svg";
export { ForwardRef as ReactComponent };